const staxMerchantStatuses = {
  notYetRegistered: "notYetRegistered",
  rejected: "rejected",
  pended: "pended",
  approved: "approved",
  submitted: "submitted",
};

const unoBackupSrc = "//dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg";
const genericError =
  "Oops, we've hit a snag! Please refresh and try again. For further assistance, email help@flocknote.com.";

export { staxMerchantStatuses, unoBackupSrc, genericError };
